import React, { useEffect, useState } from 'react';
import { CountryCode } from '@dayetopia/types';
import styled from 'styled-components';
import SEOHiddenLocalisedUrls from '@components/SEOHiddenLocalisedUrls';
import CountrySwitcher from '@components/shared/CountrySwitcher';
import { useCountry } from '@hooks/useCountry';
import useChosenCountry from '@utils/useChosenCountry';

const FooterRegionSwitcher = () => {
  const [selectedCountry, setSelectedCountry] = useState<CountryCode | null>(null);
  const { updateChosenCountry } = useChosenCountry();
  const { country } = useCountry();

  useEffect(() => {
    if (selectedCountry) {
      updateChosenCountry(selectedCountry);
    }
  }, [selectedCountry]);

  return (
    <Wrapper>
      <SEOHiddenLocalisedUrls />
      <CountrySwitcher selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} defaultCountry={country} styleVariant="footer" />
    </Wrapper>
  );
};

export default FooterRegionSwitcher;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    position: absolute;
    top: -76px;
    left: -166px;
  }

  @media (max-width: 520px) {
    left: 0;
  }

  > * {
    width: 100%;
  }
`;
